/* eslint-disable */
import React, { useState } from 'react';
import './styles/Footer.css';
import logo from '../../assets/images/moh.svg'

const Footer = ({ currentPage, setCurrentPage }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const currentYear = new Date().getFullYear();

  return (
    <footer className="ministry-footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <div className="footer-logo-section">
                <img 
                  src={logo}
                  alt="Ministry of Health" 
                  className="footer-logo"
                />
                <div className="footer-brand-info">
                  <h3>Ministry of Health</h3>
                  <p className="footer-subtitle">Republic of South Sudan</p>
                  <p className="footer-department">
                    Department of Health Security, SCD & One Health
                  </p>
                </div>
              </div>
              <p className="footer-description">
                Committed to strengthening South Sudan's health security through 
                integrated One Health approaches, emergency preparedness, and multisectoral 
                collaboration to protect communities from health threats.
              </p>
              <div className="footer-social">
                <h4>Follow Us</h4>
                <div className="social-links">
                  <a href="#" className="social-link" aria-label="Facebook">
                    <span className="social-icon">📘</span>
                    <span className="social-text">Facebook</span>
                  </a>
                  <a href="#" className="social-link" aria-label="Twitter">
                    <span className="social-icon">🐦</span>
                    <span className="social-text">X</span>
                  </a>
                  <a href="#" className="social-link" aria-label="YouTube">
                    <span className="social-icon">📹</span>
                    <span className="social-text">YouTube</span>
                  </a>
                  <a href="#" className="social-link" aria-label="LinkedIn">
                    <span className="social-icon">💼</span>
                    <span className="social-text">LinkedIn</span>
                  </a>
                </div>
              </div>
            </div>

            <div className="footer-links-sections">
              <div className="links-column">
                <h4>Quick Links</h4>
                <ul className="footer-links">
                  <li><a
                    onClick={() => {
                      setCurrentPage('');
                      setIsMobileMenuOpen(false);
                      setTimeout(() => {
                      document.getElementById('home-page')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                    }}
                  >Home</a></li>
                  <li><a
                    onClick={() => {
                      setCurrentPage('about');
                      setIsMobileMenuOpen(false);
                      setTimeout(() => {
                      document.getElementById('about-us')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                    }}
                  >About Us</a></li>
                  <li><a 
                    onClick={() => {
                      setCurrentPage('services');
                      setIsMobileMenuOpen(false);
                      setTimeout(() => {
                      document.getElementById('services-page')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                    }}
                  >Our Services</a></li>
                  <li><a
                    onClick={() => {
                      setCurrentPage('news');
                      setIsMobileMenuOpen(false);
                      setTimeout(() => {
                      document.getElementById('news-page')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                    }}
                  >News & Events</a></li>
                  <li><a
                    onClick={() => {
                      setCurrentPage('resources');
                      setIsMobileMenuOpen(false);
                      setTimeout(() => {
                      document.getElementById('resources-page')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                    }}
                  >Resources</a></li>
                  <li><a
                    onClick={() => {
                      setCurrentPage('transparency');
                      setIsMobileMenuOpen(false);
                      setTimeout(() => {
                      document.getElementById('transparency-page')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                    }}
                  >Transparency</a></li>

                  <li><a
                    onClick={() => {
                      setCurrentPage('gallery');
                      setIsMobileMenuOpen(false);
                      setTimeout(() => {
                      document.getElementById('gallery-page')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                    }}
                    >Gallery</a>
                  </li>

                </ul>
              </div>

              <div className="links-column">
                <h4>Our Services</h4>
                <ul className="footer-links">
                  <li><a
                    onClick={() => {
                      setCurrentPage('services');
                      setIsMobileMenuOpen(false);
                      setTimeout(() => {
                      document.getElementById('services-grid')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                    }}
                  >Training & Mentorship</a></li>
                  <li><a 
                    onClick={() => {
                      setCurrentPage('services');
                      setIsMobileMenuOpen(false);
                      setTimeout(() => {
                      document.getElementById('services-grid')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                    }}
                  >Vaccination Programs</a></li>
                  <li><a 
                    onClick={() => {
                      setCurrentPage('services');
                      setIsMobileMenuOpen(false);
                      setTimeout(() => {
                      document.getElementById('services-grid')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                    }}
                  >Emergency Response</a></li>
                  <li><a 
                    onClick={() => {
                      setCurrentPage('services');
                      setIsMobileMenuOpen(false);
                      setTimeout(() => {
                      document.getElementById('services-grid')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                    }}
                  >Disease Surveillance</a></li>
                  <li><a 
                    onClick={() => {
                      setCurrentPage('services');
                      setIsMobileMenuOpen(false);
                      setTimeout(() => {
                      document.getElementById('services-grid')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                    }}
                  >Research & Analytics</a></li>
                  <li><a 
                    onClick={() => {
                      setCurrentPage('services');
                      setIsMobileMenuOpen(false);
                      setTimeout(() => {
                      document.getElementById('services-grid')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                    }}
                  >Outbreak Management</a></li>
                </ul>
              </div>

              <div className="links-column">
                <h4>Support</h4>
                <ul className="footer-links">
                  <li><a
                    onClick={() => {
                      setCurrentPage('contact');
                      setIsMobileMenuOpen(false);
                      setTimeout(() => {
                      document.getElementById('contact-page')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                    }}
                  >Contact Us</a></li>
                  <li><a 
                     onClick={() => {
                      setCurrentPage('contact');
                      setIsMobileMenuOpen(false);
                      setTimeout(() => {
                      document.getElementById('email-us')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                    }}
                  >Email Us</a></li>
                  <li><a href="#feedback"
                    onClick={() => {
                      setCurrentPage('contact');
                      setIsMobileMenuOpen(false);
                      setTimeout(() => {
                      document.getElementById('social-section')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                    }}
                  >Feedback</a></li>
                  <li><a 
                    onClick={() => {
                      setCurrentPage('contact');
                      setIsMobileMenuOpen(false);
                      setTimeout(() => {
                      document.getElementById('emergency-contact')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                    }}
                  >Report Issue</a></li>
                  <li><a 
                    onClick={() => {
                      setCurrentPage('contact');
                      setIsMobileMenuOpen(false);
                      setTimeout(() => {
                      document.getElementById('map-section')?.scrollIntoView({ behavior: 'smooth' });
                    }, 0);
                    }}
                  >Sitemap</a></li>
                </ul>
              </div>
            </div>

            <div className="footer-contact">
              <h4>Contact Information</h4>
              <div className="contact-info">
                <div className="contact-item">
                  <div className="contact-icon">📍</div>
                  <div className="contact-details">
                    <p className="contact-title">Visit Our Office</p>
                    <p>Ministries Complex Road</p>
                    <p>Mobil Round About</p>
                    <p>Juba, South Sudan</p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">📞</div>
                  <div className="contact-details">
                    <p className="contact-title">Call Us</p>
                    <p>+211 912 345 678</p>
                    <p>+211 924 322 221 </p>
                    <p className="contact-note">Business Hours: 8:00 AM - 5:00 PM</p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">✉️</div>
                  <div className="contact-details">
                    <p className="contact-title">Email Us</p>
                    <p>onehealthsouthsudan@gmail.com</p>
                    <p>info.healthsecurity@gov.ss</p>
                    <p className="contact-note">Response within 24 hours</p>
                  </div>
                </div>
              </div>
    
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; {currentYear} Ministry of Health, Republic of South Sudan. All rights reserved.</p>
            </div>
            
            <div className="footer-legal">
              <div className="legal-links">
                <a href="#privacy">Privacy Policy</a>
                <a href="#terms">Terms of Use</a>
                <a href="#accessibility">Accessibility</a>
                <a href="#disclaimer">Disclaimer</a>
              </div>
            </div>

            <div className="footer-badge">
              <div className="badge-icon">🛡️</div>
              <span>Official Government Website</span>
            </div>
          </div>
        </div>
      </div>
      <button 
        className="back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="Back to top"
      >
        <span className="arrow-up">↑</span>
      </button>
    </footer>
  );
};

export default Footer;